import { render } from "./CarouselItem.vue?vue&type=template&id=2051345c"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/CarouselItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2051345c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2051345c', __exports__)) {
    api.reload('2051345c', __exports__)
  }
  
  module.hot.accept("./CarouselItem.vue?vue&type=template&id=2051345c", () => {
    api.rerender('2051345c', render)
  })

}


export default __exports__